import React, { useState } from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import { Form } from 'react-bootstrap';
import MailOutlineIcon from '@material-ui/icons/MailOutline';
import axios from 'axios';
import swal from 'sweetalert';
import { base_url, postHeader } from '../../Helpers/request';
import { useSelector } from 'react-redux';
import { Helmet } from 'react-helmet';
import ReCAPTCHA from "react-google-recaptcha";


const WarrantyRegistration = () => {
    const metaDetails = useSelector((state) => state.persistedReducer.meta.meta);
    const [first_name, setFirst_name] = useState('');
    const [last_name, setLast_name] = useState('');
    const [email, setEmail] = useState('');
    const [phone, setPhone] = useState('');
    const [message, setMessage] = useState('');
    const [capchaloading, setCapchaLoading] = useState(true)

  
    const capchaChange = (value) => {
        if (value) {
            setCapchaLoading(false)
        }
    }

    const onExpire = () => { }

    const formsubmit = (e) => {
        e.preventDefault();
        var data = {
            first_name,
            last_name,
            email,
            phone,
            message
        }
        axios.post(base_url + "/common/warranty_registration", data, {
            headers: postHeader
        })
            .then(async (response) => {
                if (response.data.status == 1) {
                    setFirst_name("");
                    setLast_name("");
                    setEmail("");
                    setMessage("");
                    setPhone("");
                    await swal(response.data.message, "", "success");
                    return window.open("https://www.google.com/search?q=diamond+for+less&oq=diamond+for+less&aqs=chrome.0.69i59j0i22i30j0i22i30i625l3j69i60l3.10624j0j7&sourceid=chrome&ie=UTF-8#lrd=0x89d4cb34a5006187:0x7d775a6a5641f2d,1,,,,", "_blank");
                } else {
                    return swal(response.data.message, "", "error");
                }
            })
            .catch((error) => {
                console.log(error);
            });
    }

    return (
        <>
            <Helmet>
                <meta charSet="utf-8" />
                <title>{metaDetails?.title}</title>
                <meta name="description" content={metaDetails?.description}></meta>
                <meta name="keywords" content={metaDetails?.keywords}></meta>
            </Helmet>
            <div className='dfl_warranty_registration_section'>
                <div className="rcs_appointment mt-4">
                    <Container>
                        <Row>
                            <div className='text-center dfl_warranty_registration_heading'>
                                <h2>Warranty Registration</h2>
                            </div>
                        </Row>
                        <Row className="w-100 m-auto">
                            <Col sm={12} md={12} lg={8} xl={8} className="p-0 text-center m-auto">
                                <Form onSubmit={formsubmit} className='dfl_warranty_registration_from'>
                                    <Row>
                                        <Col xs={12} sm={6}>
                                            <TextField
                                                id="outlined-basic"
                                                label="First Name"
                                                type="text"
                                                variant="outlined"
                                                value={first_name}
                                                onChange={(e) => setFirst_name(e.target.value)}
                                                required
                                            />
                                        </Col>
                                        <Col xs={12} sm={6}>
                                            <TextField
                                                id="outlined-basic"
                                                label="Last Name"
                                                type="text"
                                                variant="outlined"
                                                value={last_name}
                                                onChange={(e) => setLast_name(e.target.value)}
                                                required
                                            />
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col xs={12} sm={6}>
                                            <TextField
                                                id="outlined-basic"
                                                label="Email Address"
                                                type="Email"
                                                variant="outlined"
                                                value={email}
                                                onChange={(e) => setEmail(e.target.value)}
                                                required
                                            />
                                        </Col>
                                        <Col xs={12} sm={6}>
                                            <TextField
                                                id="outlined-basic"
                                                label="Phone"
                                                type="number"
                                                variant="outlined"
                                                InputProps={{ inputProps: { min: 0 } }}
                                                value={phone}
                                                onChange={(e) => setPhone(e.target.value)}
                                                required
                                            />
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col xs={12}>
                                            <TextField
                                                id="filled-multiline-static"
                                                label="Your Message"
                                                multiline
                                                rows={4}
                                                variant="outlined"
                                                value={message}
                                                onChange={(e) => setMessage(e.target.value)}
                                            />
                                        </Col>
                                        <Col  >
                                            <ReCAPTCHA
                                                sitekey="6Lc6LUscAAAAAKO2DYPGrIPSnwx3fzROCxJzNWQ0"
                                                onChange={capchaChange}
                                                onExpired={() => setCapchaLoading(true)}
                                            />
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col className='text-center mt-5'>
                                            <Button  disabled={capchaloading ? true : false} variant="contained" type="submit" className="rcs_acc_button">  Submit </Button>
                                            {/* <MailOutlineIcon className="mr-2" /> */}
                                        </Col>
                                    </Row>
                                </Form>
                            </Col>
                        </Row>
                        <Row>
                            <div className='d-flex dfl_contact_us_num_boxx mb-5'>
                                <p className='mb-0'>Contact Us:</p>
                                <a href='tel:+1 416 362 9944'>+1 416 362 9944</a>
                            </div>
                        </Row>
                    </Container>
                </div>
            </div>
        </>
    )
}

export default WarrantyRegistration